import { Form } from 'react-bootstrap';

export const GuestInformationStep = () => {
  return (
    <Form>
      <Form.Group>
        {/* TODO: update form with guest data */}
        <Form.Label>Name</Form.Label>
        <Form.Control required type="text" placeholder="Enter Name of the guest" />
      </Form.Group>
      <Form.Group>
        <Form.Label>Name</Form.Label>
        <Form.Control required type="text" placeholder="Enter Name of the guest" />
      </Form.Group>
      <Form.Group>
        <Form.Label>Name</Form.Label>
        <Form.Control required type="text" placeholder="Enter Name of the guest" />
      </Form.Group>
    </Form>
  );
};
